import React, { useEffect } from "react";
import { initTransak, transakConfig } from "../../api/transak";
import { showToast } from "../../utils/showToast";
import { Transak, TransakConfig } from "@transak/transak-sdk";
import { useSelector } from "react-redux";
import { useAccount } from "wagmi";

const Payment: React.FC = () => {
  const [orderData, setOrderData] = React.useState<any>(null);
  const [transak, setTransak] = React.useState<Transak>({} as Transak);

  const user = useSelector((state: any) => state.user.userDetails);
  const { address } = useAccount();

  // let transak = new Transak(transakConfig);

  // BUG: Unverified users accessing the page without KYC data
  useEffect(() => {
    const transakConfig: TransakConfig = initTransak(
      user ?? {
        email: "",
      },
      address,
      100,
      "USD",
      "USDC"
    );
    setTransak(new Transak(transakConfig));
  }, [user, address]);

  // To get all the events
  Transak.on("*", (data) => {
    console.log(data);
  });

  // This will trigger when the user closed the widget
  Transak.on(Transak.EVENTS.TRANSAK_WIDGET_CLOSE, () => {
    console.log("Transak SDK closed!");
  });

  /*
   * This will trigger when the user has confirmed the order
   * This doesn't guarantee that payment has completed in all scenarios
   * If you want to close/navigate away, use the TRANSAK_ORDER_SUCCESSFUL event
   */
  Transak.on(Transak.EVENTS.TRANSAK_ORDER_CREATED, (orderData) => {
    console.log(orderData);
  });

  /*
   * This will trigger when the user marks payment is made
   * You can close/navigate away at this event
   */
  Transak.on(Transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData) => {
    setOrderData(orderData);
    transak?.close();
  });

  React.useEffect(() => {
    if (orderData) {
      // console.log(
      //   `Purchase of ${orderData.status.cryptoAmount} ${orderData.status.cryptoCurrency} is successful.`
      // );
      // console.log(orderData);

      showToast(
        `Purchase of ${orderData?.status?.cryptoAmount} ${orderData?.status?.cryptoCurrency} is successful.`,
        "success"
      );
      // setTimeout(() => {
      //   transak.close();
      // }, 8000);
    }
  }, [orderData]);
  return (
    <div className="bg-[#F6F7F9] flex w-full">
      <button
        type="button"
        className="bg-[#FFFFFF] my-10 w-5/6 mx-auto text-center shadow-sm shadow-[rgba(0,0,0,0.05)]  text-[#252F40] font-Poppins text-[16px] font-semibold p-10"
        onClick={() => {
          transak.init();
        }}
      >
        On ramp with transak
      </button>
    </div>
  );
};

export default Payment;
